<template>
  <b-modal
    id="add-alternative-modal"
    ref="add-alternative-modal"
    size="lg"
    @ok="addAlternatives"
    @hide="onModalHide"
    ok-title="Add selected parts"
    :ok-disabled="!selectedIds"
    scrollable
  >
    <template slot="modal-header">
      <h5 class="modal-title">Alternative parts for {{ partNumber }}</h5>
    </template>

    <div class="modal-body">
      <b-form-group label="Alternative part">
        <b-form-input
          class="form-input"
          v-model="searchQuery"
          @input="onSearch"
          placeholder="Search"
          left
        ></b-form-input>
      </b-form-group>

      <b-table
        class="condensed inventory-alternatives--parts"
        striped
        :items="alternativesParts"
        :fields="fields"
        @row-clicked="selectPart"
        show-empty
      >
        <template slot="selected" slot-scope="row">
          <silent-padding>
            <b-form-checkbox type="checkbox" v-model="row.item.selected"/>
          </silent-padding>
        </template>
      </b-table>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import debounce from 'lodash/debounce';

import fields from './fields';
import alternativesService from '../../service';

export default {
  props: {
    alternativesIds: Array,
    partId: [Number, String],
  },
  data: () => ({
    searchQuery: '',
    fields,
  }),
  computed: {
    ...mapGetters('inventoryDetails', ['partNumberById']),
    ...mapGetters('alternatives', ['alternativesParts']),
    partNumber() {
      return this.partNumberById(this.partId)
    },
    selectedIds() {
      const data = this.alternativesParts
        .reduce((selectedList, part) => {
          if (part.selected) {
            selectedList.push(
              part.id
            );
          }
          return selectedList;
        }, [])

      return data;
    },
  },
  methods: {
    ...mapActions('alternatives', [
      'getAll', 
      'searchAlternatives', 
      'saveAlternatives', 
      'selectPart', 
      'clearAlternativesParts']),
    onSearch: debounce(async function() {
      const { partId, searchQuery: query, alternativesIds } = this;
      await this.searchAlternatives({
        partId,
        alternativesIds,
        query,
      });
    }, 500),
    addAlternatives: async function() {
      const { partId, selectedIds: alternatives } = this;
      await alternativesService.saveAlternatives({ partId, alternatives });
      await this.getAll(partId);
    },
    onModalHide() {
      this.searchQuery = '';
      this.clearAlternativesParts();
    },
  },
};
</script>

<style lang="scss">
.inventory-alternatives {
  &--parts {
    margin-top: 20px;
  }
}
</style>
